export enum ScreeningQuestionVideoStatus {
  NoVideo = 'no_video',
  Processing = 'processing',
  Success = 'success',
  Failed = 'failed'
}

export const getScreeningQuestionVideoStatusLabel = (status: ScreeningQuestionVideoStatus) => {
  switch (status) {
    case ScreeningQuestionVideoStatus.NoVideo:
      return 'No Video';
    case ScreeningQuestionVideoStatus.Processing:
      return 'Processing';
    case ScreeningQuestionVideoStatus.Success:
      return 'Success';
    case ScreeningQuestionVideoStatus.Failed:
      return 'Failed';
    default:
      return 'Unknown';
  }
};
